import React from 'react'
import { useTheme } from '@emotion/react'
import { Card, Link, Typography } from '../base-ui'
import { Image } from './'
import { generateUrl } from '../../utils'
import { useTranslation } from 'next-i18next'

function ProductCard({ entity, type = 'product' }) {
    const theme = useTheme()
    const { t } = useTranslation(['common'])
    if (!entity) return null
    const productStyle = `
        height: 100%;
        border-Radius: 0;
        .card-body {
            padding: 0;
        }
        .product-content {
            padding: 1rem;
            position: relative;
            height: 250px;
        }
        .product-category {
            padding: 0.5rem 2rem;
            background-color: ${theme.colors.primary}; 
            position: absolute;
            bottom: 10px;
            color: #ffffff;
        }
        .product-image {
            position: relative;
        }
        button {
            border: 1px solid ${theme.colors.primary};
            color: ${theme.colors.primary};
            border-radius: 0;
            padding: 0.5rem;
            justify-content: center;
            width: 90%;
            margin: 0 auto;
            position: absolute;
            bottom: 15px;
        }
    `
    return (
        <Card bordered style={productStyle}>
            <div className="product-image">
                <Image
                    src={
                        entity?.thumbnail?.file?.hash &&
                        `/api/filedb/${entity?.thumbnail.file.hash}.${entity?.thumbnail.file.ext}`
                    }
                    width={1280}
                    height={720}
                    objectFit="cover"
                    alt={entity?.thumbnail?.alt ?? entity.title}
                />
                {entity?.services?.map((s) => (
                    <span key={s.id} className="product-category">
                        {s.title}
                    </span>
                ))}
            </div>
            <div className="product-content">
                <Typography type="h3" lineClamp={3}>
                    {entity.title}
                </Typography>
                <Typography type="p" lineClamp={2}>
                    {entity.abst}
                </Typography>
                <Link href={generateUrl(entity, type)}>
                    <button>{t('بیشتر بخوانید', { ns: 'common' })}</button>
                </Link>
            </div>
        </Card>
    )
}

export default ProductCard
